import { render, staticRenderFns } from "./TerminalHandlingCharge.vue?vue&type=template&id=4f2b0515&scoped=true&"
import script from "./TerminalHandlingCharge.vue?vue&type=script&lang=js&"
export * from "./TerminalHandlingCharge.vue?vue&type=script&lang=js&"
import style0 from "./TerminalHandlingCharge.vue?vue&type=style&index=0&id=4f2b0515&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b0515",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VTextField})
